import { PageWithLayout } from '@/pages/_app';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { TextReplacementContent } from '@/pageContents/textReplacements/TextReplacementContent';
import { Permission } from '@/models/user';

const TextReplacements: PageWithLayout = () => {
    return (
        <>
            <Helmet>Text ersetzungen | Starjack Backoffice</Helmet>

            <TextReplacementContent />
        </>
    );
};

TextReplacements.isProtected = true;
TextReplacements.getLayout = (Comp) => <SidebarLayout>{Comp}</SidebarLayout>;
TextReplacements.permissions = [Permission.ADMIN];

export default TextReplacements;
